<template>
  <div class="mt-6 w-full rounded-lg bg-gray-ultralight p-4">
    <div
      :class="{
        'border-b border-b-gray-300 pb-6': !isRequesting,
      }"
      class="flex items-center justify-between pb-3 pt-3 transition duration-200 ease-in-out"
    >
      <span
        v-t="'pages.collection.delivery_options.title'"
        class="text-xl font-semibold"
      />

      <SpinnerIcon v-if="isRequesting" size="w-7 h-7" />
    </div>

    <div
      v-if="!isRequesting && paazlStore.deliveryOptions.length"
      class="w-full divide-y divide-solid divide-gray-300"
    >
      <div
        v-for="(deliveryOption, index) in paazlStore.deliveryOptions"
        :key="`delivery_option_${index}`"
        class="flex items-center justify-between py-3"
      >
        <!-- Name and date -->
        <div class="flex flex-col">
          <span class="font-extrabold">{{ deliveryOption.name }}</span>
          <span>
            {{ formatDate(deliveryOption.date.deliveryDate) }}
          </span>
        </div>

        <!-- Price -->
        <span v-if="deliveryOption.rate > 0">
          {{ formatPrice(deliveryOption.rate) }}
        </span>

        <!-- No price -->
        <span
          v-else
          v-t="'pages.collection.delivery_options.free_shipping'"
          class="text-order-buttons"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { usePriceFormatter } from '@/composables/UsePriceFormatter';
import _ from 'lodash';
import SpinnerIcon from '@/components/Icons/SpinnerIcon.vue';
import { usePaazlStore } from '@/stores/Paazl/PaazlStore.ts';
import { computed, type ComputedRef } from 'vue';

const paazlStore = usePaazlStore();
const isRequesting: ComputedRef<boolean> = computed(
  () => paazlStore.deliveryOptionsRequest.isLoading
);
const formatPrice = usePriceFormatter().formatPrice;

function formatDate(date: string) {
  const locale = window.locale.replace('_', '-');
  return _.startCase(
    new Date(date).toLocaleDateString(locale, {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    })
  );
}
</script>
